<template>
  <div class="d-flex">
    <navigator />
    <div class="create-session">
      <div class="title-header">
        <h1 v-if="userType == 1"> Create Session </h1>
        <h1 v-if="userType == 2"> Create Template </h1>
      </div>
      <div class="sesssion-container">
        <div>
          <transition name="fade">
            <Loading v-if="isLoading"></Loading>
          </transition>
        </div>
                <SessionMetaData :template="template" :adminOrDev="userType" @update-instructions="handleInstructionsUpdate" @update-testers-valid="handleTestersValidUpdate"/>
        <!--<SessionMetaDataTest :template="template" :adminOrDev="userType" @update-instructions="handleInstructionsUpdate"/>-->
      </div>
      <div class="session-nav">
        <div class="session-nav-button">
          <b-button v-on:click="() => clickPrevious()" class="nav-button">Previous</b-button>
        </div>
            <div class="session-nav-button">
            <b-button 
            v-on:click="() => createSession()" 
            class="nav-button" 
            :disabled="userType === 1 && !testersValid"
            :class="{ 'disabled-button': userType === 1 && !testersValid }"
          >
            Add to Project
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navigator from '../layout/NavBarNew.vue';
import Loading from "../loading/index.vue"
import GamesObject from "../../Firestore/GamesObject.js";
import SessionMetaData from "../session-create/SessionMetaData.vue";

export default {
  name: 'CreateSession',
  components: {
    navigator,
    Loading,
    SessionMetaData,
  },
  data() {
    return {
      userId: window.localStorage.getItem('userId'),
      isLoading: false,
      testersValid: false,
      userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1,
      step: 1,
      template: {
        "name": "",
        "tags": [],
        "description": "",
        "questions": [],
        "startTime": "",
        "endTime": "",
        "transcription": "",    //changed back to string, although this should be a boolean
        "instructions": [],
        "testerIds": [],  // populated by SessionMetaData when developer selects testers
        "link": "", 
      },
      devSteps: ["Select Template", "Session Details", "Add Questions", "Add to Project"],
      adminSteps: ["Session Details", "Add Questions", "Publish"],
      project: {}
    }
  },
  mounted() {
    if (!window.localStorage.getItem("userType") || !window.localStorage.getItem("userId")) {
      this.$router.push({ name: 'login' });
    }
    //commented out because it displays error saying the reference was null
    //should try and resolve this most likely
    /*GamesObject.getProject(window.localStorage.getItem("gameID"))
      .then(res => {
        this.project = res.data
      })
    */
    this.showLoadingScreen();
    GamesObject.getProject(window.localStorage.getItem("gameId"))
      .then(res => {
        this.project = res.data;
      });
  },
  methods: {
    showLoadingScreen() {
      this.isLoading = true;
      setTimeout(() => this.isLoading = false, 200);
    },
    clickPrevious() {
      this.sendToGameDetail();
    },
      createSession() {
      ///// I will most likely need to create some sort of validation to ensure fields are not empty similar to handleConfirm in AddGame.vue /////
      // Create playtest period, throw it into the playPeriod array within "Games" collection.
        if (this.userType == 1 && (!this.template.testerIds || this.template.testerIds.length === 0)) {
        alert("Please select at least one tester before adding to project.");
        return;
      }
      if (this.userType == 1) {
        const gameId = window.localStorage.getItem("gameId");
        const userId = window.localStorage.getItem("userId");
        const selectedTesterIds = this.template.testerIds || [];

        this.isLoading = true;

        // Step 1: Create the playPeriod document. createPlaytestPeriod now resolves
        // with { success: true, playPeriodId: <newId> } so we can use the ID
        // in the follow-up calls below.
        GamesObject.createPlaytestPeriod(
          "-1",
          gameId,
          userId,
          JSON.parse(JSON.stringify(this.template.tags)),
          JSON.parse(JSON.stringify(this.template.questions)),
          this.template.instructions,
          this.template.startTime,
          this.template.endTime,
          this.template.description,
          this.template.name,
          this.template.transcription,
          this.template.link,
        )
        .then(res => {
          const playPeriodId = res.playPeriodId;

          // Step 2: Link the new playPeriod ID to the game project
          GamesObject.attachPlayPeriodToProject(gameId, playPeriodId);

          // Step 3: If the developer selected testers in the modal, formally
          // assign them to this playPeriod so they appear in the session
          if (selectedTesterIds.length > 0) {
            GamesObject.updateTestersToPlayPeriod(playPeriodId, selectedTesterIds)
              .then(() => {
                this.isLoading = false;
                this.sendToGameDetail();
              })
              .catch(err => {
                console.error("Failed to assign testers to play period:", err);
                this.isLoading = false;
                this.sendToGameDetail();
              });
          } else {
            this.isLoading = false;
            this.sendToGameDetail();
          }
        })
        .catch(err => {
          console.error("Failed to create session:", err);
          this.isLoading = false;
        });
      }
    },
    sendToGameDetail() {
      window.localStorage.setItem("gameDetailIndex", 2);
      this.$router.push({ name: 'gamedetail' });
    },
        handleInstructionsUpdate(instructions) {
      this.template.instructions = instructions;
      //console.log(this.template.instructions);
    },
    handleTestersValidUpdate(isValid) {
      this.testersValid = isValid;
    }
  }
}
</script>

<style scoped>
.create-session {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  margin: 0px 0px 0px auto;
  background-color: #EEEEEE;
}

.title-header {
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75px;
  width: 100%;
  box-shadow: 0 4px 10px -6px grey;
}

.title-header h1 {
  color: #FF7222;
  font-weight: bold;
}

h4 {
  color: #FF7222;
  font-weight: bold;
  margin: 1rem 0px;
}

.session-container {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
}

.session-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  padding: 0.5rem;
  box-shadow: 0px -4px 10px -6px grey;
  width: 100%;
}

.session-nav-button {
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-button {
  background: #FF7222 !important;
  margin: 5px;
  border: 0 !important;
  width: 8rem;
  height: 2.5rem;
}

button.nav-button:hover {
  background: #ff8e4d !important;
}

.nav-button:active,
.nav-button:focus {
  background: #FF7222 !important;
}

.nav-button[disabled],
.nav-button.disabled-button {
  background: #6c757d !important;
  cursor: not-allowed;
}

.publish-button {
  background: #FF7222 !important;
  margin: 5px;
  border: 0 !important;
  position: relative;
}

.publish-button:hover {
  background: #ff8e4d !important;
}

.publish-button:focus,
.publish-button:active {
  background: #FF7222 !important;
}

.close-button {
  background: #6c757d !important;
  margin: 5px;
  border: 0 !important;
  position: relative;
}

.close-button:hover {
  background: #848d94 !important;
}

.close-button:focus,
.close-button:active {
  background: #6c757d !important;
}

.placeholder-container {
  margin: 1rem;
  background-color: white;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

button {
  border: 0 !important;
  background-color: transparent !important;
}

.confirm-modal-text {
  color: black !important;
  margin: 0.5rem;
}

::v-deep .question-container {
  margin: 1rem 0.5rem 0 0.5rem;
  padding: 1.5rem 3rem;
  background-color: white;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 80%;
}

::v-deep .question-text-box {
  border-color: lightgray;
  border-top-style: none;
  border-left-style: none;
  border-right-style: none;
  border-bottom-style: solid;
  border-width: thin;
  padding: 0.5rem;
  width: 60%;
  font-size: large;
}

::v-deep .question-title-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 80%;
}

::v-deep .question-title {
  color: #FF7222;
  width: 100%;
}

::v-deep .question-number {
  color: #FF7222;
  margin: 0;
  padding-right: 1rem;
  font-weight: bold !important;
}

::v-deep .question-head-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}

::v-deep .question-type-text {
  color: lightgray !important;
  font-style: italic;
}

::v-deep .option-container {
  display: flex;
  width: 100%;
  margin: 0.5rem !important;
  align-items: center;
}

::v-deep .option-text-box {
  border-color: lightgray;
  border-top-style: none;
  border-left-style: none;
  border-right-style: none;
  border-bottom-style: solid;
  border-width: thin;
  padding: 0.5rem !important;
  min-width: 15%;
  max-width: 85%;
  margin-left: 1rem;
}

::v-deep .add-option-div {
  width: 100%;
  margin: 0.5rem !important;
}

::v-deep .add-option {
  background: transparent !important;
  border: 0 !important;
  color: gray !important;
  margin-left: 2rem;
}

::v-deep .add-option:hover {
  background: lightgray !important;
  color: white !important;
}

::v-deep .add-option:focus, .add-option:active {
  color: gray !important;
}
</style>


// WEBPACK FOOTER //
// src/components/session-create/CreateSessionBase.vue